<cll-dialog-layout>
    <cll-dialog-header>
        <cll-dialog-title>Reply</cll-dialog-title>
        <cll-dialog-subtitle>{{data.subject}}</cll-dialog-subtitle>
    </cll-dialog-header>
    <div class="dialog-detail">
        <div class="dialog-container-header">
            <cll-icon type="outlined" [size]="24">message</cll-icon>
            <span class="dialog-container-header-text">Message</span>
        </div>
        <div>
            <cll-form-field label="Message">
                <textarea cllFormInput
                           rows="4" 
                           [formControl]="replyFormGroup.controls.content"></textarea>
            </cll-form-field>
        </div>
    </div>
    <span class="dialog-divider"></span>
    <cll-dialog-footer>
        <button cll-button
                colour="variant"
                cllDialogClose>
            Cancel
        </button>
        <button cll-filled-button
                colour="secondary" (click)="addReply()">
            <cll-icon type="outlined">send</cll-icon>
            Send
        </button>
    </cll-dialog-footer>
</cll-dialog-layout>

